export const typeOfSynthesisJobRetryDialog = 'typeOfSynthesisJobRetryDialog';
